"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateCurrencies = exports.convertCurrencyToUsd = exports.convertUsdToCurrency = exports.currencyConvert = void 0;
/**
 * Calculates the exchange rate between two currencies.
 *
 * @template R - Rates type parameter.
 * @template C - Currencies type parameter.
 * @param {R} rates - The rates object containing currency rates.
 * @param {C} sourceCurrency - The source currency code.
 * @param {C} targetCurrency - The target currency code.
 * @throws {Error} - If the rate for the source or target currency is not found.
 * @returns {number} - The exchange rate between the source and target currencies.
 */
const getRate = (rates, sourceCurrency, targetCurrency) => {
    if (!(sourceCurrency in rates) ||
        !(targetCurrency in rates) ||
        !(rates === null || rates === void 0 ? void 0 : rates[sourceCurrency]) ||
        !(rates === null || rates === void 0 ? void 0 : rates[targetCurrency])) {
        throw new Error(`Could not find rate for currency: ${sourceCurrency} or ${targetCurrency}`);
    }
    return rates[targetCurrency] / rates[sourceCurrency];
};
const currencyConvert = ({ amount, rates, sourceCurrency, targetCurrency, }) => amount * getRate(rates, sourceCurrency, targetCurrency);
exports.currencyConvert = currencyConvert;
const convertUsdToCurrency = ({ amount, rates, targetCurrency, }) => (0, exports.currencyConvert)({
    amount,
    rates,
    sourceCurrency: 'USD',
    targetCurrency,
});
exports.convertUsdToCurrency = convertUsdToCurrency;
const convertCurrencyToUsd = ({ amount, rates, sourceCurrency, }) => (0, exports.currencyConvert)({
    amount,
    rates,
    sourceCurrency,
    targetCurrency: 'USD',
});
exports.convertCurrencyToUsd = convertCurrencyToUsd;
/**
 * Calculates the amount in various currencies based on the source currency and exchange rates.
 *
 * @template R - The type for the exchange rates.
 * @template C - The type for the currencies.
 * @param {number} amount - The amount to be converted.
 * @param {C} sourceCurrency - The source currency to convert from.
 * @param {R} rates - The exchange rates for various currencies.
 * @returns {R} - A record with converted amounts in different currencies. Can be another `amountCurrencies` from which it infers the rates.
 */
const calculateCurrencies = (amount, sourceCurrency, rates) => {
    const amountCurrencies = {};
    for (const targetCurrency of Object.keys(rates)) {
        amountCurrencies[targetCurrency] = (0, exports.currencyConvert)({
            amount,
            rates,
            sourceCurrency,
            targetCurrency,
        });
    }
    return amountCurrencies;
};
exports.calculateCurrencies = calculateCurrencies;
//# sourceMappingURL=convert.js.map